(function () {
  var SLICK_CSS = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css';
  var SLICK_JS  = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js';
  var JQUERY_JS = 'https://code.jquery.com/jquery-3.6.0.min.js';

  var state = 'idle'; // idle | loading | ready | failed
  var callbacks = [];

  function isJQueryReady() {
    return !!(window.jQuery && typeof window.jQuery === 'function');
  }

  function isSlickReady() {
    return !!(window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.slick === 'function');
  }

  function flushCallbacks() {
    state = 'ready';
    var cbs = callbacks.slice();
    callbacks = [];
    cbs.forEach(function (cb) {
      try { cb(); } catch (e) { console.error('[slick-loader] callback error', e); }
    });
  }

  function failCallbacks() {
    state = 'failed';
    console.warn('[slick-loader] Failed to load Slick carousel');
    callbacks = [];
  }

  function loadCss() {
    if (document.querySelector('link[data-slick-shared]')) return;
    var link = document.createElement('link');
    // Non-blocking CSS load
    link.rel = 'preload';
    link.as = 'style';
    link.href = SLICK_CSS;
    link.setAttribute('data-slick-shared', '1');
    link.onload = function () { this.rel = 'stylesheet'; };
    document.head.appendChild(link);
  }

  function loadScript(src, onload, onerror) {
    if (document.querySelector('script[src="' + src + '"]')) {
      // Script tag exists but may still be loading — just wait for onload
      onload();
      return;
    }
    var script = document.createElement('script');
    script.src = src;
    script.defer = true;
    script.onload = onload;
    script.onerror = onerror || function () { failCallbacks(); };
    document.head.appendChild(script);
  }

  function loadSlick() {
    if (isSlickReady()) { flushCallbacks(); return; }

    loadScript(SLICK_JS, function () {
      if (isSlickReady()) {
        flushCallbacks();
      } else {
        // Slick loaded but jQuery wasn't available — shouldn't happen
        // if we gated correctly, but guard anyway
        console.warn('[slick-loader] Slick loaded but $.fn.slick missing');
        failCallbacks();
      }
    });
  }

  function start() {
    if (state === 'ready')   { flushCallbacks(); return; }
    if (state === 'loading') { return; }
    if (state === 'failed')  { return; }
    state = 'loading';

    loadCss();

    if (isSlickReady()) {
      flushCallbacks();
    } else if (isJQueryReady()) {
      loadSlick();
    } else {
      // jQuery not on page yet — load it first, then Slick
      loadScript(JQUERY_JS, function () {
        if (!isJQueryReady()) { failCallbacks(); return; }
        loadSlick();
      });
    }
  }

  window.ensureSlickLoaded = function (callback) {
    if (typeof callback === 'function') {
      if (state === 'ready') {
        // Already ready — fire immediately, don't re-queue
        try { callback(); } catch (e) { console.error('[slick-loader] callback error', e); }
        return;
      }
      callbacks.push(callback);
    }
    start();
  };
})();